import { HitData, SearchFilters, SearchQuery } from 'common/store/common/search/types';
import commonSearchQueryBuilder from 'common/services/search/commonSearchQueryBuilder';
import commonApiService from 'common/services/api/commonApiService';
import { ITEM_INDEX, QTI_CONTEXT_INDEX } from '../../store/common';

const listLiveDataObjectLoaderService = {
    async getContextDataObject(dataType: string, contextId: number, qtiContextItemId: number, itemBankId?: number, isObjectIdOnly?: boolean) {
        let filters: SearchFilters;
        switch (dataType) {
        case QTI_CONTEXT_INDEX:
            filters = {
                contextId,
                objectId: qtiContextItemId,
            };
            if (itemBankId > 0) {
                filters.itemBankId = itemBankId;
            }
            break;
        case ITEM_INDEX:
            if (isObjectIdOnly) {
                filters = {
                    objectId: qtiContextItemId,
                };
            } else {
                filters = {
                    objectId: contextId,
                };
            }
            if (itemBankId > 0) {
                filters.itemBankId = itemBankId;
            }
            break;
        default:
            filters = {
                objectId: contextId,
            };
            if (itemBankId > 0) {
                filters.itemBankId = itemBankId;
            }
            break;
        }
        const query: SearchQuery = commonSearchQueryBuilder.createQueryWithFilterAndSort(
            filters,
            'title',
            'asc',
            1,
        );

        const searchQueryJSON: string = encodeURIComponent(JSON.stringify(query));

        const response = await commonApiService.fetchListLiveData(dataType, searchQueryJSON);
        return response?.hits?.[0];
    },

    async getScorableItemObject(contextId: number, scorableItemContextId: number, itemBankId?: number) {
        const filters: SearchFilters = {
            contextId,
            objectId: scorableItemContextId,
        };

        if (itemBankId > 0) {
            filters.itemBankId = itemBankId;
        }

        return {
            objectId: scorableItemContextId,
            title: scorableItemContextId,
        };
    },

    async getAnswerKeyConfig(dataType: string, itemBankId?: number) {
        const filters: SearchFilters = {
            contentType: 'content_preset_answer_key_configuration',
            itemBankId,
            publishStatus: 'finished',
            isTrashed: false,
        };
        if (itemBankId > 0) {
            filters.itemBankId = itemBankId;
        }

        const query: SearchQuery = commonSearchQueryBuilder.createQueryWithFilterAndSort(
            filters, 'title', 'asc',
        );

        const searchQueryJSON: string = encodeURIComponent(JSON.stringify(query));
        const response = await commonApiService.fetchListLiveData(dataType, searchQueryJSON);

        return response.hits;
    },

    async getAnswerKeyTypes(dataType: string, itemBankId: number) {
        const filters: SearchFilters = {
            contentType: 'content_preset_answer_key_type',
            itemBankId,
            publishStatus: 'finished',
            isTrashed: false,
        };
        if (itemBankId > 0) {
            filters.itemBankId = itemBankId;
        }

        const query: SearchQuery = commonSearchQueryBuilder.createQueryWithFilterAndSort(
            filters, 'title', 'asc',
        );

        const searchQueryJSON: string = encodeURIComponent(JSON.stringify(query));
        const response = await commonApiService.fetchListLiveData(dataType, searchQueryJSON);

        return response.hits;
    },

    async getPciResourceTemplates(dataType: string, itemBankId?: number): Promise<HitData[]> {
        const filters: SearchFilters = {
            contentType: 'content_preset_pci_template',
            interactionTypeForTemplate: 'pci_resource',
            publishStatus: 'finished',
            isTrashed: false,
        };

        if (itemBankId && itemBankId > 0) {
            filters.itemBankId = itemBankId;
        }

        const query = commonSearchQueryBuilder.createQueryWithFilterAndSort(
            filters, 'title', 'asc'
        );

        const searchQueryJSON = encodeURIComponent(JSON.stringify(query));
        const response = await commonApiService.fetchListLiveData(dataType, searchQueryJSON);

        return response?.hits || [];
    },

    async getPciStimulusTemplates(dataType: string, itemBankId?: number): Promise<HitData[]> {
        const filters: SearchFilters = {
            contentType: 'content_preset_pci_template',
            interactionTypeForTemplate: 'pci_stimulus',
            publishStatus: 'finished',
            isTrashed: false,
        };

        if (itemBankId && itemBankId > 0) {
            filters.itemBankId = itemBankId;
        }

        const query = commonSearchQueryBuilder.createQueryWithFilterAndSort(
            filters, 'title', 'asc'
        );

        const searchQueryJSON = encodeURIComponent(JSON.stringify(query));
        const response = await commonApiService.fetchListLiveData(dataType, searchQueryJSON);

        return response?.hits || [];
    },
};

export default listLiveDataObjectLoaderService;
